import { CircleSwitcherItem, Switcher } from "@similarweb/ui-components";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import type { IDataType } from "app/components/React/GraphTypeSwitcher/GraphTypeSwitcher";

interface IGraphTypeSwitcherProps {
    onItemClick: (index: number) => void;
    selectedIndex: number;
    buttonsList: IDataType[];
}

const { carbon } = colorsPalettes;

const GraphTypeSwitcherContainer = styled(Switcher)`
    border-right: 1px solid ${carbon[50]};
    height: fit-content;
`;

export const GraphTypeSwitcher = (props: IGraphTypeSwitcherProps) => {
    const { onItemClick, selectedIndex, buttonsList } = props;
    return (
        <GraphTypeSwitcherContainer
            selectedIndex={selectedIndex}
            onItemClick={onItemClick}
        >
            {buttonsList.map(({ title, value, disabled }, index) => (
                <CircleSwitcherItem
                    key={index}
                    disabled={disabled}
                >
                    {title}
                </CircleSwitcherItem>
            ))}
        </GraphTypeSwitcherContainer>
    );
};
